var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Tabs as CharkaTabs, TabList as CharkaTabList, TabPanels as ChakraTabPanels, Tab as ChakraTab, TabPanel as ChakraTabPanel, } from "@chakra-ui/react";
/**
 * An accessible tabs component
 */
export const Tabs = forwardRef((_a, ref) => {
    var { colorScheme, variantColor = "primary", children, isLazy = true } = _a, props = __rest(_a, ["colorScheme", "variantColor", "children", "isLazy"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    return (React.createElement(CharkaTabs, Object.assign({ ref: ref, colorScheme: scheme, isLazy: isLazy }, props), children));
});
Tabs.displayName = "Tabs";
export default Tabs;
export const TabList = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React.createElement(CharkaTabList, Object.assign({}, props), children);
};
export const TabPanels = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React.createElement(ChakraTabPanels, Object.assign({}, props), children);
};
export const TabPanel = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React.createElement(ChakraTabPanel, Object.assign({}, props), children);
};
export const Tab = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React.createElement(ChakraTab, Object.assign({}, props), children);
};
//# sourceMappingURL=Tabs.js.map